export const validateMobileNumber = (value: string) => {
  if (!/^[0-9]{10}$/.test(value)) return false;
};

export const validateOtpDigit = (value: string) => {
  if (!/^[0-9]{1}$/.test(value)) return false;
};

export const validatePinCode = (value: string) => {
  if (!/^[0-9]{6}$/.test(value)) return false;
};

export const validateAlpha = (value: string) => {
  if (!/^[A-Za-z ]$/.test(value)) return false;
};

export const validateAlphaNumaric = (value: string) => {
  if (!/^[A-Za-z0-9 ]$/.test(value)) return false;
};

export const inputOnlyNumbers = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    event.preventDefault(); // Prevent entering non-numeric characters
  }
};

export const validateEmailRegex =
  /^(?!.*\.\.@)[a-zA-Z0-9](\.?[a-zA-Z0-9_%+-])*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
export const MOBILE_NUMBER_REGEX = /^[6-9]\d{9}$/;
export const REGEX_MAP: {
  [key: string]: RegExp;
} = {
  MOBILE: MOBILE_NUMBER_REGEX,
  EMAIL: validateEmailRegex,
  CASE_ID: /^CM-(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{2}-[A-Z0-9]{8}$/,
  PINCODE: /^[1-9][0-9]{5}$/,
  FULL_NAME: /^[A-Za-z\s]{3,}$/,
};

export const sanitize = (value: string) => value.replaceAll(/[&<>'"/\\]/g, '');
